/*
 * Filename: layout-config-root.component.tsx
 * Description: component for config tabs.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import LayoutFieldsConfigController from '../layout-level-fields.controller';
import './layout-config.css';
import { TemplateSFObjectStore } from '../../../store/models/template-object.model';
import TemplateConfigurationController from '../template-config.controller';
import { CQStoreManager } from '../../../store/store-manager';
import { CQAppConstant } from '../../../app-constants';
import { AddNbaModalComponent } from  './add-nba-modal.component';

class LayoutConfigurationRootComponent extends Component<{ selectedObject?:string, templateName: string }, { selectedFields: any, layoutMetadata: any, isAddNbaModalVisible: boolean }> {

    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private readonly templateConfigCtrl: TemplateConfigurationController;
    private readonly storeManagerCtrl: CQStoreManager;
    public fieldData: any;
    public fieldObject: any;
    constructor(props: Readonly<{ selectedObject?:string, templateName: string }>) {
        super(props);
        this.state = {
            selectedFields: null,
            layoutMetadata: null,
            isAddNbaModalVisible: false
        };
        this.templateConfigCtrl = new TemplateConfigurationController();
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
        this.storeManagerCtrl = new CQStoreManager();
        this.init();
    }

    /**
     * @memberof LayoutConfigurationRootComponent
     */
    init = () => {
        const layout = CQMasterDataStore.OutputConfig.getTemplateLayoutMetadata(this.props.templateName);
        if (layout && layout.layout && Object.keys(layout.layout).length !== 0) {
            this.layoutFieldsConfigCtrl.setFields(layout);
        }
    }

    render(): ReactNode {
        const layout = CQMasterDataStore.OutputConfig.getTemplateLayoutMetadata(this.props.templateName);
        const ruleObject: any = CQMasterDataStore.RuleElements.FieldRuleElement;
        let selectedObjectName: any = CQMasterDataStore.OutputConfig.getSelectedObject(this.props.templateName);
        selectedObjectName = selectedObjectName?selectedObjectName:this.props.selectedObject;

        return (
            <div id="tab-default-2" className="slds-tabs_default__content slds-p-around_small scroll-content"
                role="tabpanel" aria-labelledby="tab-default-2__item">
                {
                    layout && layout.layout && Object.keys(layout.layout).length !== 0 &&(
                        <div className="slds-grid slds-grid_align-end slds-border_bottom slds-p-vertical_medium">
                            <button className="slds-button slds-button_brand" onClick={() => this.templateConfigCtrl.refreshLayout(this.props.templateName)} >
                                Refresh Layout
                            </button>
                            <button className="slds-button slds-button_brand" onClick={() => this.setLayoutEventData()} >Component Event</button>
                        </div>
                    )
                }
                {
                    layout && layout.layout && Object.keys(layout.layout).length !== 0 && ruleObject && ruleObject.hasOwnProperty('componentLayout') ? <div>
                        <h1>Applied event rules : </h1>
                        {Object.keys(ruleObject['componentLayout']).map((ruleKey: string, index: number) => {
                            return <h1 key={index}>{ruleKey}</h1>;
                        })}

                    </div> : null
                }
                {
                    layout && Object.keys(layout).length !== 0 &&
                    <>
                        {
                            layout &&
                            layout.layout.layoutSections &&
                            layout.layout.layoutSections.map((layoutSection: any, index: number) => {
                                return (
                                    <div key={index}>
                                        < div className="slds-section slds-is-open">
                                            <h3 className="slds-section__title slds-theme_shade">
                                                <span className="slds-truncate slds-p-horizontal_small" title="Section Title">{layoutSection.label}</span>
                                            </h3>
                                        </div>
                                        {
                                            this.displayFieldColumns(layoutSection).map((chunkArray: any, LayoutFieldsRowIndex: number) => {
                                                return (
                                                    <div key={LayoutFieldsRowIndex} className="slds-grid slds-gutters slds-wrap">
                                                        {

                                                            chunkArray.map((chunk: any, rowFieldIndex: number) => {
                                                                let fieldData:any;
                                                                if(chunk.emptySpace){
                                                                    fieldData = false;
                                                                }else{
                                                                    fieldData = this.layoutFieldsConfigCtrl.getFieldDetails(layout, chunk.field);
                                                                }
                                                                const classNameValue = rowFieldIndex > 0 ? 'slds-col slds-size_1-of-2' : 'slds-col'; 
                                                                return (
                                                                    <React.Fragment key={rowFieldIndex}>
                                                                        {!fieldData &&
                                                                        <div className={classNameValue}>
                                                                            <span className="slds-assistive-text">Empty Space</span>
                                                                        </div>
                                                                        }
                                                                        {fieldData &&
                                                                            <div className={classNameValue}>
                                                                                <div key={chunk.field} className="slds-form-element">
                                                                                    <label className="slds-form-element__label">
                                                                                        {fieldData.label}</label>
                                                                                    <div className="slds-form-element__control">
                                                                                        <input type="text" id="text-input-id-1"
                                                                                            readOnly className="slds-input" value=""
                                                                                            onClick={() => this.setFieldData(fieldData, chunk)} />
                                                                                        {
                                                                                            ruleObject && ruleObject.hasOwnProperty(chunk.field) ? <div>
                                                                                                <h1>Added Form Rules : </h1>
                                                                                                {Object.keys(ruleObject[chunk.field]).map((ruleKey: string, ruleIndex: number) => {
                                                                                                    return <h1 key={ruleIndex}>{ruleKey}</h1>;
                                                                                                })}

                                                                                            </div> : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                );
                            })
                        }
                    </>
                }
                {
                    layout && Object.keys(layout).length === 0 && this.props.templateName!==CQAppConstant.CQNBA &&
                    <div>
                        Please select layout
                    </div>
                }
                {
                    !selectedObjectName && this.props.templateName===CQAppConstant.CQNBA &&
                    <div>
                        Please select Object
                    </div>
                }
                {
                    this.state.isAddNbaModalVisible && <AddNbaModalComponent
                        toggleNbaModalVisibility={this.toggleNbaModalVisibility}
                    ></AddNbaModalComponent>
                }
                {this.props.templateName ===CQAppConstant.CQNBA && selectedObjectName &&
                    <>
                        <div className="slds-form-element slds-grid slds-wrap">
                            <div className="slds-col slds-size_1-of-5"></div>
                            <div className="slds-col slds-size_3-of-5">
                                <div className="slds-col slds-size_1-of-2">
                                    <button role='button' 
                                        onClick={() => { this.toggleNbaModalVisibility(); }} 
                                        className="slds-button slds-button_brand full-width slds-m-bottom_small">
                                            Add NBA
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="slds-form-element slds-grid slds-wrap">
                            <div className="slds-col slds-size_1-of-5"></div>
                            <div className="slds-col slds-size_3-of-5">
                                <div className="slds-col">
                                    <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">
                                        Next Best Actions
                                    </label>
                                </div>
                                <div className="slds-grid slds-wrap slds-button-group" role="group">
                                    {
                                        CQMasterDataStore.OutputConfig['cqNBA'].quickActions && CQMasterDataStore.OutputConfig['cqNBA'].quickActions.map((quickAction) => {
                                            return(<button className="slds-button slds-button_neutral"
                                                disabled={false}
                                                role='nba-buttons'
                                                key={quickAction.fullName}
                                                onClick={()=>this.setFieldDataForNba(quickAction)}
                                                >{quickAction.type===CQAppConstant.NBA_TYPES.NOTIFICATION?'MSG'+' : '+quickAction.label : quickAction.label}</button>);
                                        })
                                    }
                                    
                                </div>
                            </div>
                        </div>

                    </>
                }
            </div >
        );
    }

    /**
     * @memberof LayoutConfigurationRootComponent
     * @param quickAction
     * @description sets the selected field detail store
     */
     public setFieldDataForNba = (quickAction:any) => {
        let fieldData = { type: quickAction.type, label:quickAction.label, fullName:quickAction.fullName, isComponentEventRule: false };
        CQMasterDataStore.Details.setSelectedFieldDetailsObject(fieldData);
    }

    /**
     * @memberof LayoutConfigurationRootComponent
     */
    public setFieldData = (fieldObject: any, chunk: any) => {
        let fieldData = { ...fieldObject, behavior: chunk.behavior, objectName: fieldObject.fullName, isComponentEventRule: false };
        // 
        CQMasterDataStore.Details.setSelectedFieldDetailsObject(fieldData);
        CQMasterDataStore.PicklistValueSource.setSelectedPicklistValue(fieldObject.fullName);
    }

    /** 
     * @memberof LayoutConfigurationRootComponent
    */
     private toggleNbaModalVisibility = () => {
        this.setState({
            isAddNbaModalVisible: !this.state.isAddNbaModalVisible
        })
    }

    /**
    * @memberof LayoutConfigurationRootComponent
    */
    public setLayoutEventData = () => {
        const layoutEvents = { isComponentEventRule: true, fullName: 'componentLayout', objectName: 'componentLayout', label: 'componentLayout', type: 'component' };
        CQMasterDataStore.Details.setSelectedFieldDetailsObject(layoutEvents);
    }

    /**
     * @memberof LayoutConfigurationRootComponent
     */
    public displayFieldColumns = (layoutSection: any) => {
        return this.layoutFieldsConfigCtrl.getColumnChunks(layoutSection.columnSize, layoutSection.layoutColumns);
    }

}

export const LayoutConfigRootComponent = observer(LayoutConfigurationRootComponent);